import React, { useState, useEffect } from "react";
import thiepMoi from "../assets/images/thiepmoi.jpg";
import "./Card.css"; // Make sure to create this CSS file

const Card = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [ribbonEmojis, setRibbonEmojis] = useState([]);

  useEffect(() => {
    // Animation timing - show card after a short delay
    setTimeout(() => {
      setIsVisible(true);
    }, 500);

    // Generate new ribbon emojis periodically
    const ribbonInterval = setInterval(() => {
      const newRibbon = {
        id: Math.random().toString(36).substr(2, 9),
        left: Math.random() * 90 + 5, // 5-95% from left
        delay: Math.random() * 0.5, // Random delay for animation start
      };

      setRibbonEmojis((prev) => [...prev, newRibbon]);

      // Remove emoji after animation completes to prevent memory issues
      setTimeout(() => {
        setRibbonEmojis((prev) =>
          prev.filter((ribbon) => ribbon.id !== newRibbon.id)
        );
      }, 8000); // Should match or exceed total animation time
    }, 800); // Create a new ribbon emoji every 800ms

    return () => clearInterval(ribbonInterval);
  }, []);

  return (
    <div className={`card-container ${isVisible ? "visible" : ""}`}>
      <div className="invitation-frame" id="invitation-frame">
        {/* Gold decorative corners */}
        <div className="corner top-left"></div>
        <div className="corner top-right"></div>
        <div className="corner bottom-left"></div>
        <div className="corner bottom-right"></div>

        {/* Shine effect overlay */}
        <div className="shine-effect"></div>

        {/* Wedding invitation image */}
        <div className="image-container">
          <div className="image-overlay"></div>
          <img
            src={thiepMoi}
            alt="Thiệp mời đám cưới"
            className="invitation-image"
          />

          {/* Sparkle effects */}
          <div className="sparkles">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="sparkle"
                style={{
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 2}s`,
                  animationDuration: `${2 + Math.random() * 3}s`,
                }}
              ></div>
            ))}
          </div>
        </div>

        {/* Decorative divider */}
        <div className="divider">
          <div className="divider-line"></div>
          <div className="divider-symbol">❦</div>
          <div className="divider-line"></div>
        </div>

        {/* Card content placeholder text */}
        <div className="card-content">
          <h2 className="card-title">Thiệp Mời Đám Cưới</h2>
          <p className="card-subtitle">Trân trọng kính mời</p>
          <p className="card-message">Quý khách đến dự buổi lễ thành hôn</p>
        </div>

        {/* Floating flower animations */}
        <div className="floating-flowers">
          {[...Array(10)].map((_, i) => (
            <div
              key={i}
              className="flower"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${10 + Math.random() * 15}s`,
              }}
            >
              {["✿", "❀", "❁", "✽"][Math.floor(Math.random() * 4)]}
            </div>
          ))}
        </div>

        {/* Pink ribbons floating effect */}
        <div className="floating-ribbons">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="ribbon"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${12 + Math.random() * 8}s`,
                transform: `rotate(${Math.random() * 360}deg) scale(${
                  0.7 + Math.random() * 0.5
                })`,
              }}
            >
              <div className="ribbon-bow">
                <div className="ribbon-left"></div>
                <div className="ribbon-right"></div>
                <div className="ribbon-knot"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Floating ribbon emojis rising from bottom */}
        <div className="ribbon-emojis-container">
          {ribbonEmojis.map((ribbon) => (
            <div
              key={ribbon.id}
              className="ribbon-emoji"
              style={{
                left: `${ribbon.left}%`,
                animationDelay: `${ribbon.delay}s`,
              }}
            >
              🎀
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card;
